<template>
  <div>
    <footer class="footer bg-dark text-white text-center text-uppercase p-2">
      Copyright &copy; {{ moment().year() }} SchoolGood & developed by <a href="https://gohze.org" target="_blank" class="text-green">GOHZE</a>
    </footer>
  </div>
</template>

<script>
import moment from 'moment';

export default {
  data() {
    return {}
  },
  methods: {
    moment
  }
}
</script>
<style lang="scss">
</style>
